export default async function init() {
  const element = document.querySelector('.infobar');

  if (element) {
    const { default: Infobar } = await import(/* webpackChunkName: "infobar" */ './infobar');

    new Infobar(element);
  }
}
